<template>
  <div class="index-alert-main" v-show="alertData.show">
    <transition name="opacity">
      <div class="cover" @click="close"></div>
    </transition>
    <transition name="alert">
      <div class="box wechatPlublic" >
        <p class="title">超级简历公众号</p>
        <p class="msg">关注公众号，为你推荐最新校招信息</p>
        <div class="qrCode pr" style="position: relative">
          <img src="https://files.wondercv.com/wxPublic.png" class="qrCodeReload">
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    alertData: {
      default() {return {}}
    },
	useStateShow: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
}
</script>
<style lang="scss" scoped>
  .el-icon-loading{
    position: absolute;
    font-size: 32px;
    color: #BCBCBC;
    top: calc(50% - 16px);
    left: calc(50% - 16px);
  }
.index-alert-main {
  position: fixed;
  width: 0;
  height: 0;
  top: 0;
  left: 0;
  z-index: 100;
  .box {
    background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    .title {
      color: #404040;
      font-size: 24px;
      font-weight: 400;
      margin-top: 42px;
    }
    .msg {
      color: #9C9C9C;
      margin-top: 15px;
      font-size: 14px;
      font-weight: 400;
    }
    &.wechatPlublic{
      top: calc(50% - 200px);
      width:340px;
      height:380px;
      text-align: center;
      border-radius: 6px;
      .qrCode{
        width: 230px;
        height: 230px;
        // padding-top: 25px;
        position: relative;
        margin: 22px auto 0;
        .qrCodeReload{
          position: absolute;
          left: 0px;
          // top: 25px;
          display: block;
          cursor: pointer;
          width: 230px;
          height: 230px;
          margin: auto;
        }
      }
    }
  }
}
</style>
